import React from 'react';
import { SiUpwork } from "react-icons/si";

const IconUpwork = () => < SiUpwork/>;
 export default IconUpwork;